import { RefObject, useEffect, useRef } from "react";
import { logException } from "@wss/error-tracking";

async function loadDialogPolyfill(element: HTMLDialogElement): Promise<void> {
  try {
    const dialogPolyfill = await import("dialog-polyfill");
    dialogPolyfill.default.registerDialog(element);
  } catch (error) {
    logException(error);
  }
}

type UseDialogPolyfill = RefObject<HTMLDialogElement>;

/** */
export function useDialogPolyfill(
  controlledRef?: RefObject<HTMLDialogElement>,
): UseDialogPolyfill {
  const internalRef = useRef<HTMLDialogElement>(null);
  const ref = controlledRef ?? internalRef;

  useEffect(
    function initDialogPolyfill() {
      if (typeof HTMLDialogElement !== "function") {
        if (!ref.current) {
          throw new Error(
            "Dialog polyfill does not have a valid ref or selector.",
          );
        }
        loadDialogPolyfill(ref.current);
      }
    },
    [ref],
  );

  return ref;
}
